import {combineReducers} from 'redux';
import entreprise_infos  from './infos';
import perspectives from './perspectives';

export default combineReducers({
    entreprise_infos,
    perspectives
})


// WEBPACK FOOTER //
// ./src/reducers/entreprise/_index.js